import { UtenteProfilo } from '../../../models/profili-utente/utente-profilo';

export class UtenteAdapter {
  utente: UtenteProfilo = new UtenteProfilo();
  constructor(utente: UtenteProfilo) {
    if (utente.id) {
      this.utente.id = utente.id;
    }
    this.utente.nome = utente.nome;
    this.utente.cognome = utente.cognome;
    this.utente.codiceFiscale = utente.codiceFiscale;
    this.utente.username = utente.username;
    this.utente.email = utente.email;
    this.utente.pec = utente.pec;
//    this.utente.templateProfilo = utente.templateProfilo ? JSON.parse(JSON.stringify(utente.templateProfilo)) : new TemplateUtente();
 }
}
